const includes = require('lodash.includes');

export function movies() {
  const trigger = document.querySelectorAll('.js-trigger-date');
  const movie = document.querySelectorAll('.js-movie-element');
  const reset = document.querySelector('.js-trigger-date-reset');
  if(trigger && movie) {
    for (let i = 0; i < trigger.length; i++) {
      const el = trigger[i];
      el.addEventListener('click', function(e) {
        e.preventDefault();
        const date = el.dataset.date;
        for (let i = 0; i < movie.length; i++) {
          const _el = movie[i];
          const _date = _el.dataset.date;
          if(includes(_date, date)) {
            _el.classList.remove('hide')
          } else {
            _el.classList.add('hide')
          }
        }
        for (let i = 0; i < trigger.length; i++) {
          const el = trigger[i];
          el.classList.remove('is-current')
        }
        el.classList.add('is-current');
        if(reset){
          reset.classList.remove('is-current');
        }
        return false;
      });
    }
    if(reset) {
      reset.addEventListener('click', function(e) {
        e.preventDefault();
        for (let i = 0; i < trigger.length; i++) {
          const el = trigger[i];
          el.classList.remove('is-current')
        }
        for (let i = 0; i < movie.length; i++) {
          const _el = movie[i];
          _el.classList.remove('hide')
        }
        reset.classList.add('is-current');
        return false;
      });
    }
  }
}